export default __webpack_public_path__ + "static/media/GPA_Banner_WhatWereDoing.eafc193c.jpg";